import { increment } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useState } from 'react';
export var useRetry = function useRetry(maxTimes, retryAction) {
  var _useState = useState(0),
      retryCounter = _useState[0],
      setRetryCounter = _useState[1];

  return retryCounter < maxTimes ? O.some(function () {
    setRetryCounter(increment);
    retryAction();
  }) : O.none;
};